jQuery(document).ready(function($) {
    var interesting_keys = {
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        224: 'cmd'
    };

    var css = [];
    Object.keys(interesting_keys).forEach(function(k) {
        css.push('[data-show-on-'+interesting_keys[k]+'-press] { display: none; }');
    });
    $('head').append('<style>'+css.join('')+'</style>');

    $(window).bind('keydown.keys_pressed', function(event) {
        var code = event.keyCode;
        if(interesting_keys[code]) {
            var arr = window['pressed_keys'];
            if(arr == undefined) {
                arr = [];
            }
            if(arr.indexOf(parseInt(code)) < 0) {
                arr.push(code);
            }
            var code_name = interesting_keys[code];
            $('[data-show-on-'+code_name+'-press]').show();
            window['pressed_keys'] = arr;
        }
    }).bind('keyup.keys_pressed', function(event) {
        var code = event.keyCode;
        if(interesting_keys[code]) {
            var arr = window['pressed_keys'];
            if(arr == undefined) {
                arr = [];
            }

            var new_arr = [];
            arr.forEach(function(v) {
                if(v != code) {
                    new_arr.push(v);
                }
            });

            var code_name = interesting_keys[code];
            $('[data-show-on-'+code_name+'-press]').hide();

            window['pressed_keys'] = new_arr;
        }
    });

    window['pressed'] = function(name) {
        var looking_for = 0;
        Object.keys(interesting_keys).forEach(function(k) {
            if(interesting_keys[k] == name) {
                looking_for = k;
            }
        });

        if(looking_for > 0) {
            var arr = window['pressed_keys'];
            if(arr == undefined) {
                arr = [];
            }
            var found = false;
            arr.forEach(function(v) {
                if(v == looking_for) {
                    found = true;
                }
            })
            return found;
        }
        return false;
    };
});